import { render, staticRenderFns } from "./ShareWorkForm.vue?vue&type=template&id=6e098c59"
import script from "./ShareWorkForm.vue?vue&type=script&lang=js"
export * from "./ShareWorkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports